<tm-modal [modalConfig]="{width: '900px'}" title="圖檔上傳" panelClass="image-upload-modal" #modal
(afterCancel)="onCancel()"
(afterConfirm)="onConform()">
  <tm-modal-header></tm-modal-header>
  <tm-modal-body>
    <div class="col-12">
      <label for="imageUploadModalPcFiles">電腦版圖檔</label>
      <p *ngIf="uploadSetting">{{ 'upload.uploadType' | translate }}<span class="extention">{{uploadSetting.ext.join(', ')}}</span></p>
      <app-img-upload *ngIf="modal.isOpened"
      type="image"
      name="pcFiles"
      id="imageUploadModalPcFiles"
      [(ngModel)]="pcFiles"
      [single]="singleImage"
      [showFileType]="false"
      [uploadSetting]="uploadSetting"
      [upload2Serv]="uploadFile2Server"
      (uploadFailedEvent)="onUploadFailedEvent($event, globalComponentService, isBrowser)"
      [label]="{
        uploadType: ('upload.uploadType' | translate) + ': ',
        dropAreaText: ('upload.dropAreaText' | translate),
        representImg: '',
        setRepresentImgTitle: ''
      }">
      </app-img-upload>
    </div>
    <div class="col-12">
      <label for="imageUploadModalMobileFiles">手機版圖檔</label>
      <p *ngIf="uploadSetting">{{ 'upload.uploadType' | translate }}<span class="extention">{{uploadSetting.ext.join(', ')}}</span></p>
      <app-img-upload *ngIf="modal.isOpened"
      type="image"
      name="mobileFiles"
      id="imageUploadModalMobileFiles"
      [(ngModel)]="mobileFiles"
      [single]="singleImage"
      [showFileType]="false"
      [uploadSetting]="uploadSetting"
      [upload2Serv]="uploadFile2Server"
      (uploadFailedEvent)="onUploadFailedEvent($event, globalComponentService, isBrowser)"
      [label]="{
        uploadType: ('upload.uploadType' | translate) + ': ',
        dropAreaText: ('upload.dropAreaText' | translate),
        representImg: '',
        setRepresentImgTitle: ''
      }">
      </app-img-upload>
    </div>
  </tm-modal-body>
  <tm-modal-footer>
    <div #tmModalFooter>
      <button class="btn btn-default" type="button" (click)="modal.close(modal.CLOSE_REASON.SUBMIT)" [disabled]="!pcFiles || !pcFiles.length || !mobileFiles || !mobileFiles.length">完成</button> 
    </div>
  </tm-modal-footer>
</tm-modal>